import { PURGE } from 'redux-persist/es/constants';

const initialState = {
  scoreTags: []
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ScoreTags/SET': {
      return { ...state, scoreTags: action.payload };
    }
    case PURGE: {
      return initialState;
    }

    default:
      return state;
  }
};
export default appReducer;
